export default __webpack_public_path__ + "fonts/6da07201b1ffd10eeeea570c17602f7c.svg";